// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Nc4J","right":"Footer_right__umGbc","buttons":"Footer_buttons__16ctz"};